// Implements: F-VER-008
/**
 * The notes of a mockup's versions, by version id, for the timeline (mockup v3 P4). Kept under its
 * own key next to the tree's: a saved note refreshes it (`VersionNoteContainer`).
 */

import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { fetchVersionNotes } from "../api/versionsApi";

export function versionNotesKey(mockupId: string): readonly ["versions", "notes", string] {
  return ["versions", "notes", mockupId] as const;
}

export function useVersionNotes(mockupId: string): UseQueryResult<ReadonlyMap<string, string | null>, ApiError> {
  return useQuery<ReadonlyMap<string, string | null>, ApiError>({
    queryKey: versionNotesKey(mockupId),
    queryFn: () => fetchVersionNotes(mockupId),
  });
}
